import { useRef } from "react";

export const toDateInputValue = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const toDisplayDateValue = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const DateFilterField = ({
  label,
  value,
  min,
  max,
  onChange,
  parseValue,
}) => {
  const inputRef = useRef(null);

  const openDatePicker = () => {
    const input = inputRef.current;
    if (!input) return;

    try {
      if (typeof input.showPicker === "function") {
        input.showPicker();
      } else {
        input.click();
      }
    } catch {
      input.click();
    }
  };

  return (
    <label className="relative min-w-[180px]">
      <span className="mb-1 block text-xs font-medium text-slate-700 dark:text-slate-300">
        {label}
      </span>
      <button
        type="button"
        onClick={openDatePicker}
        className="h-9 w-full cursor-pointer rounded-lg border border-slate-300 bg-white px-3 text-left text-sm text-slate-900 shadow-sm outline-none transition focus:border-slate-400 focus:ring-2 focus:ring-indigo-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100"
      >
        {toDisplayDateValue(value)}
      </button>
      <input
        ref={inputRef}
        type="date"
        tabIndex={-1}
        aria-hidden="true"
        value={toDateInputValue(value)}
        min={min}
        max={max}
        onChange={(event) => onChange(parseValue(event.target.value))}
        className="pointer-events-none absolute inset-x-0 bottom-0 h-9 w-full opacity-0"
      />
    </label>
  );
};

export default DateFilterField;
